import { Component, EventEmitter, Output } from '@angular/core';
import { SearchService } from '../../../models/search/searchService'; 
import { GlobalSearchRecord } from '../../../models/search/GlobalSearchRecord';
import { Merchant } from '../../../models/merchant/merchant';
import { TransactionFacade } from '../../../models/transactions/transactionFacade';
import { Customer } from '../../../models/customer/customer';
import { Account } from '../../../models/account/account';
import { MerchantService } from '../../../models/merchant/merchantService';
import { TransactionService } from '../../../models/transactions/transactionService';
import { AccountService } from '../../../models/account/accountService';
import { UserService } from '../../../models/users/userService';
import { CustomerService } from '../../../models/customer/customerService';
import { TableView } from '../../ui/filterable-table/tableView';
import { GlobalSearchTableViewComponent } from '../global-search-table-view/global-search-table-view.component';
import { SearchFilters } from '../../../models/search/searchFilters';
import { TableViewFilters } from '../../ui/filterable-table/tableViewFilters';
import { GlobalSearchFiltersComponent } from '../global-search-filters/global-search-filters.component';
import { UIErrorHandler } from '../../../core/uiErrorHandler';

@Component({
  selector: 'app-omni-search',
  templateUrl: './omni-search.component.html',
  standalone: false,
})
export class OmniSearchComponent {
  @Output() checkRecordDetailsIsVisible = new EventEmitter<boolean>();

  filterParams: SearchFilters = new SearchFilters({});

  tableView: any;
  searchTableOptions: any = {
    queryOnLoad: false,
  };

  tableViewFilters: any;

  viewingDetails: boolean = false;
  selectedMerchant: Merchant | undefined;
  selectedTransaction: TransactionFacade | undefined;
  selectedCustomer: Customer | undefined;
  selectedAccount: Account | undefined;

  constructor(
    private merchantService: MerchantService,
    private transactionService: TransactionService,
    private accountService: AccountService,
    private userService: UserService,
    private customerService: CustomerService,
    private searchService: SearchService,
    private uiErrorHandler: UIErrorHandler,
  ) {
    this.tableView = new TableView(GlobalSearchTableViewComponent);
    this.tableViewFilters = new TableViewFilters(GlobalSearchFiltersComponent);

    // We will configure this search UI to filter on all major record types:
    // User, Merchant, Account, Customer, and Transaction

    this.filterParams.filters =
      this.searchService.getSearchFields('mySearchForm');
  }

  handleRecordSelected(record: GlobalSearchRecord) {
    this.clearSelectedDetails();

    switch (record.type) {
      case 'business':
        this.loadSelectedAccountDetails(record.id);
        break;

      case 'customer':
        this.loadSelectedCustomerDetails(record.id);
        break;

      case 'merchant':
        this.loadSelectedMerchantDetails(record.id);
        break;

      case 'transaction':
        this.loadSelectedTransactionDetails(record.id);
        break;

      case 'user':
        this.loadSelectedUserDetails(record.id);
        break;

      default:
        this.viewingDetails = false;

        return;
    }

    this.viewingDetails = true;
    this.checkRecordDetailsIsVisible.emit(true);
  }

  btnCloseDetails_click() {
    this.clearSelectedDetails();
    this.viewingDetails = false;
    this.checkRecordDetailsIsVisible.emit(false);
  }

  private clearSelectedDetails() {
    this.selectedMerchant = undefined;
    this.selectedTransaction = undefined;
    this.selectedCustomer = undefined;
    this.selectedAccount = undefined;
  }

  private loadSelectedAccountDetails(recordId: string) {
    this.accountService
      .getAccount(recordId)
      .then((account) => {
        this.selectedAccount = account;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  private loadSelectedCustomerDetails(recordId: string) {
    this.customerService
      .getCustomerById(recordId)
      .then((customer) => {
        this.selectedCustomer = customer;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  private loadSelectedMerchantDetails(recordId: string) {
    this.merchantService
      .getMerchantById(recordId)
      .then((merchant) => {
        this.selectedMerchant = merchant;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  private loadSelectedTransactionDetails(recordId: string) {
    this.transactionService
      .getTransaction(recordId)
      .then((trans) => {
        this.selectedTransaction = trans;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  private loadSelectedUserDetails(recordId: string) {}
}
/*
export class SearchField {

  public searchFieldId:string;
  public fieldName: string;
  public fieldType:string = "text";
  public filterValue: string;
  public items: ListItem[];

  constructor(field: Partial<SearchField>) {
    if (field.searchFieldId) {
      this.searchFieldId = field.searchFieldId;
    } else {
      throw "field must have an id";
    }
    //if (field.columnName) {
    //  this.columnName = field.columnName;
    //} else {
    //  throw "field must have a column name";
   // }
    if (field.fieldName) {
      this.fieldName = field.fieldName;
    } else {
      throw "field must have a field name";
    }

    if (field.fieldType) {
      this.fieldType = field.fieldType;
    } else {
      this.fieldType = "text";
    }

    if (field.items) {
      this.items = field.items;
    } else {
      this.items = [];
    }

    if (field.filterValue) {
      this.filterValue = field.filterValue;
    } else {
      this.filterValue = "";
    }
  }
}
  */
